import React from "react";

import {Container,} from "reactstrap";

// import images

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

import {useQuery,} from "react-query";

import {getMasterSystems} from "../../helpers/fakebackend_helper";

const MasterSystem = () => {

  //meta title
  document.title = "MasterSystems | Temperstack";

  const {isLoading, error, data, isFetching} = useQuery({
    queryKey: ["masterResource"], queryFn: getMasterSystems
  });

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumbs title="UI Elements" breadcrumbItem="Monitoring Systems"/>
        </Container>
      </div>
    </React.Fragment>
  );
};
export default MasterSystem;
